import React from 'react';
import './Spinner.scss';
const Spinner = () => {
    return ( 
        <>
        <div className="spinner"></div>
        <p className="text-center">Cargando</p>
        </>
     );
}
 
export default Spinner;